import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setPatientExternalDocuments } from 'src/store/modules/patient'

import {
  EXTERNAL_REFERRAL_ATTACHMENT,
  GET_PATCH_DELETE_PATIENT_EXTERNAL_DOCUMENT,
  GET_PATIENT_EXTERNAL_DOCUMENTS,
  PATIENT_EXTERNAL_DOCUMENT_SUCCESS_DELETE_MESSAGE,
  PATIENT_EXTERNAL_DOCUMENT_SUCCESS_UPLOAD_MESSAGE,
  POST_PATIENT_EXTERNAL_DOCUMENT
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'
import { exportReport } from 'src/utils/Functions'

export const fetchPatientExternalDocuments =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATIENT_EXTERNAL_DOCUMENTS,
          ...config
        }
      })

      dispatch(setPatientExternalDocuments(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const uploadPatientExternalDocument =
  (config = {}) =>
  async () => {
    try {
      const { params = {}, data = {} } = config

      await httpClient.upload({
        url: {
          pathname: POST_PATIENT_EXTERNAL_DOCUMENT,
          params
        },
        data
      })

      showSuccessModal({
        content: PATIENT_EXTERNAL_DOCUMENT_SUCCESS_UPLOAD_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updatePatientExternalDocument =
  (config = {}) =>
  async () => {
    try {
      const { params = {}, data = {} } = config

      await httpClient.upload({
        url: {
          pathname: GET_PATCH_DELETE_PATIENT_EXTERNAL_DOCUMENT,
          params
        },
        data
      })

      showSuccessModal({
        content: PATIENT_EXTERNAL_DOCUMENT_SUCCESS_UPLOAD_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const downloadPatientExternalDocument = async (config = {}) => {
  await exportReport({
    pathname: GET_PATCH_DELETE_PATIENT_EXTERNAL_DOCUMENT,
    ...config
  })
}

export const previewPatientExternalDocument = async (config = {}) => {
  const { params } = config

  try {
    const { data } = await httpClient.request({
      method: 'get',
      url: {
        pathname: GET_PATCH_DELETE_PATIENT_EXTERNAL_DOCUMENT,
        params
      },
      isDownload: true // this should still return the blob data
    })

    const blob = new Blob([data], { type: 'application/pdf' }) // ensure it's PDF
    const url = window.URL.createObjectURL(blob)

    // Open in new tab
    window.open(url, '_blank')
  } catch (err) {
    catchError(err)
  }
}

export const deletePatientExternalDocument = async (config = {}) => {
  const { params } = config

  try {
    await httpClient.request({
      method: 'delete',
      url: {
        pathname: GET_PATCH_DELETE_PATIENT_EXTERNAL_DOCUMENT,
        params
      }
    })

    showSuccessModal({
      content: PATIENT_EXTERNAL_DOCUMENT_SUCCESS_DELETE_MESSAGE,
      centered: true,
      keyboard: false
    })

    return true
  } catch (err) {
    catchError(err)

    return false
  }
}

export const downloadExternalReferralAttachment = async (config = {}) => {
  const { fileName, ...restConfig } = config

  const response = await httpClient.request({
    method: 'get',
    url: {
      pathname: EXTERNAL_REFERRAL_ATTACHMENT,
      ...restConfig,
      query: fileName ? { fileName } : undefined
    },
    isDownload: true
  })

  if (!response?.data) {
    throw new Error('Failed to download attachment')
  }

  const contentDisposition = response.headers?.['content-disposition']
  const resolvedFileName =
    contentDisposition?.replace(/.*filename="?([^"]*)"?.*/, '$1') ||
    fileName ||
    'attachment'

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute('download', resolvedFileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(blobUrl)
}
